import { SettingLandingReservationInformationContainer } from "../";

export const SettingLandingReservationMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingLandingReservationInformationContainer />
    </div>
  );
};
